import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ContactForm() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', message: '' });

  const onSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    // Frontend only — fake latency, then redirect
    setTimeout(() => {
      navigate('/thank_you');
    }, 600);
  };

  return (
    <form onSubmit={onSubmit} className="bg-white border border-[#0B1E3F]/10 rounded-3xl p-6 md:p-8 shadow-[0_20px_60px_-30px_rgba(11,30,63,0.25)]" data-testid="contact-form">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-[12px] font-semibold uppercase tracking-wider text-[#0B1E3F]/70 mb-2">{t('contact.nameLabel')}</label>
          <input
            required
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            placeholder={t('contact.namePlaceholder')}
            className="w-full bg-[#F6F3EE] border border-transparent focus:border-[#0B1E3F]/30 rounded-xl px-4 py-3 text-[14px] outline-none transition"
            data-testid="contact-name"
          />
        </div>
        <div>
          <label className="block text-[12px] font-semibold uppercase tracking-wider text-[#0B1E3F]/70 mb-2">{t('contact.emailLabel')}</label>
          <input
            required
            type="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            placeholder={t('contact.emailPlaceholder')}
            className="w-full bg-[#F6F3EE] border border-transparent focus:border-[#0B1E3F]/30 rounded-xl px-4 py-3 text-[14px] outline-none transition"
            data-testid="contact-email"
          />
        </div>
      </div>
      <div className="mt-4">
        <label className="block text-[12px] font-semibold uppercase tracking-wider text-[#0B1E3F]/70 mb-2">{t('contact.messageLabel')}</label>
        <textarea
          required
          rows={5}
          value={form.message}
          onChange={(e) => setForm({ ...form, message: e.target.value })}
          placeholder={t('contact.messagePlaceholder')}
          className="w-full bg-[#F6F3EE] border border-transparent focus:border-[#0B1E3F]/30 rounded-xl px-4 py-3 text-[14px] outline-none transition resize-none"
          data-testid="contact-message"
        />
      </div>
      <div className="mt-5 flex flex-col md:flex-row md:items-center gap-4 justify-between">
        <p className="text-[11.5px] text-[#0B1E3F]/60 max-w-sm">{t('contact.privacy')}</p>
        <button
          type="submit"
          disabled={submitting}
          className="bg-[#0B1E3F] hover:bg-[#12295a] disabled:opacity-60 text-white text-[14px] font-semibold px-6 py-3 rounded-full transition"
          data-testid="contact-submit"
        >
          {submitting ? t('contact.submitting') : t('contact.submit')}
        </button>
      </div>
    </form>
  );
}
